import { createReducer } from "@reduxjs/toolkit";
import {
  DeleteVisitorSuccess,
  GetCompletedVisitorList,
  getCompletedVisitorListSuccess,
  GetVisitorList,
  getVisitorListSuccess,
  GetVisitorLogList,
  getVisitorLogListSuccess,
  loadingCompletedVisitorList,
  loadingList,
  loadingVisitorLogList,
  saveVisitorListSuccess,
} from "./visitorAction";

export interface IVisitorState {
  visitorList?: Array<any>;
  visitorLogList?: Array<any>;
  dataCount: number;
  isLoading?: boolean;
  completedVisitorList?: Array<any>;
  completedDataCount: number;
  isCompletedLoading?: boolean;
}
const initialState: IVisitorState = {
  visitorList: [],
  visitorLogList: [],
  dataCount: 0,
  isLoading: false,
  completedVisitorList: [],
  completedDataCount: 0,
  isCompletedLoading: false,
};
export const VisitorReducer = createReducer(initialState, (builder) => {
  builder

    .addCase(getVisitorListSuccess, (state, action) => {
      state = {
        ...state,
        visitorList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(DeleteVisitorSuccess, (state, action) => {
      let filteredData = state.visitorList.filter(
        (item) => !action.payload.includes(item.id)
      );
      state = {
        ...state,
        visitorList: filteredData,
      };
      return state;
    })
    .addCase(GetVisitorList.fulfilled, (state, action) => {
      state = {
        ...state,
        visitorList: action.payload?.data,
        dataCount: action.payload?.dataCount,
        isLoading: false,
      };
      return state;
    })
    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(saveVisitorListSuccess, (state, action) => {
      state = {
        ...state,
        visitorList: action.payload,
      };
      return state;
    })
    .addCase(getVisitorLogListSuccess, (state, action) => {
      state = {
        ...state,
        visitorLogList: action.payload?.data,
      };
      return state;
    })
    .addCase(GetVisitorLogList.fulfilled, (state, action) => {
      state = {
        ...state,
        visitorLogList: action.payload?.data,
        isLoading: false,
      };
      return state;
    })
    .addCase(loadingVisitorLogList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getCompletedVisitorListSuccess, (state, action) => {
      state = {
        ...state,
        completedVisitorList: action.payload?.data,
        completedDataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(GetCompletedVisitorList.fulfilled, (state, action) => {
      state = {
        ...state,
        completedVisitorList: action.payload?.data,
        completedDataCount: action.payload?.dataCount,
        isCompletedLoading: false,
      };
      return state;
    })
    .addCase(loadingCompletedVisitorList, (state, action) => {
      state = {
        ...state,
        isCompletedLoading: action.payload,
      };
      return state;
    })
});
